import type React from 'react';
import { Box, type BoxProps, Flex } from '@chakra-ui/react';
import { KText } from '@/ui-library/components';
import moment from 'moment-timezone';

interface CalEventContentProps {
  title?: string;
  time?: string;
  interviewer?: string;
  containerProps?: BoxProps;
  eventInfo?: any;
  colors?: { bg; color };
  onClick?: () => void;
}

export const CalEventContent: React.FC<CalEventContentProps> = ({
  title,
  time,
  interviewer,
  colors,
  eventInfo,
  onClick,
}) => {
  const textProps = {
    variant: 'small_text' as const,
    whiteSpace: 'nowrap' as const,
    color: colors?.color,
    isTruncated: false,
    enableTooltip: false,
  };

  const { event } = eventInfo ?? {};
  const { startStr, endStr } = event || {};
  const minutes = moment(endStr).diff(moment(startStr), 'minutes');

  let padding = '6px';

  if (minutes <= 15) {
    padding = '0px 2px';
  } else if (minutes <= 30) {
    padding = '4px';
  }

  return (
    <Box w="100%" h="100%" p={padding} overflow="hidden" onClick={onClick}>
      <Flex direction="column" minW={0}>
        {title && (
          <KText
            {...textProps}
            isTruncated
            enableTooltip
            isTextTruncatedDefault
            tooltipText={
              <Flex flexDir="column">
                {title && <p>{title}</p>}
                {time && <p>{time}</p>}
                {interviewer && <p>{interviewer}</p>}
              </Flex>
            }
          >
            {title}
          </KText>
        )}
        {time && <KText {...textProps}>{time}</KText>}
        {interviewer && <KText {...textProps}>{interviewer}</KText>}
      </Flex>
    </Box>
  );
};
